import { PostTagUpdateStore, updatePostTagUseCase } from "./updatePostTagUseCase";


const setPostTagUseCase = (store: PostTagUpdateStore,tag: string) => updatePostTagUseCase(store, tag);

export { setPostTagUseCase }